export default __webpack_public_path__ + "img/android-chrome-192x192.e95a3aaa.png";